import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@/config/siteConfig";
import { Reveal } from "@/components/Reveal";

export const Faq = () => (
  <section id="faq" className="border-t border-black/5 bg-gray-50 py-24 md:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-3xl px-4 md:px-8">
      <Reveal className="mb-12 text-center">
        <p className="mb-3 font-display text-xs font-bold uppercase tracking-[0.3em] text-gray-400">06 — FAQ</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl">
          Questions fréquentes
        </h2>
        <p className="mt-4 text-base text-gray-600">
          Une autre question ? Écrivez-nous sur WhatsApp, on vous répond rapidement.
        </p>
      </Reveal>

      <Reveal>
        <Accordion type="single" collapsible className="rounded-3xl border border-gray-200 bg-white px-6 md:px-8">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-gray-100">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="py-5 text-left font-display text-base font-bold text-black hover:no-underline md:text-lg"
              >
                {item.question}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="pb-5 text-base leading-relaxed text-gray-600">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
